import { LoadableLazy } from '@confluence/loadable';
import { LoadingState } from '../src/SpacesDropdownLoadingState.tsx';

export const SpacesDropdown = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-global-spaces-dropdown" */ '../src/SpacesDropdown.tsx'
			)
		).SpacesDropdown,
});
export const SpacesDropdownLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-global-spaces-dropdown" */ '../src/SpacesDropdown.tsx'
			)
		).SpacesDropdown,
	loading: LoadingState,
});
